import { render, staticRenderFns } from "./ProfileMessagingPay.vue?vue&type=template&id=c0c23a08&"
import script from "./ProfileMessagingPay.vue?vue&type=script&lang=js&"
export * from "./ProfileMessagingPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports